import { useEffect } from "react";

/**
 * iOS Safari force-scrolls the <html> element when an input gains focus,
 * even with `overflow: hidden`. This hook resets that scroll immediately.
 *
 * We cannot use `position: fixed` on <html> to prevent it because in PWA
 * standalone mode, iOS constrains fixed elements to the safe viewport,
 * which doubles up with `env(safe-area-inset-bottom)` on child elements.
 *
 * @see docs/decisions/ios-root-scroll.md
 */
export function useIosScrollFix() {
  useEffect(() => {
    const resetScroll = () => {
      requestAnimationFrame(() => {
        document.documentElement.scrollTop = 0;
      });
    };
    document.addEventListener("focusin", resetScroll);
    return () => document.removeEventListener("focusin", resetScroll);
  }, []);
}
